export default __webpack_public_path__ + "static/media/sectionFive.da99f35d.jpg";